import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';

import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { TreeProgramTopHeader } from 'components/common';
import { RiskRegisterTabs } from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs';

export const RiskRegisterPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.riskRegister.title });
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={excellenceAppsConfig.riskRegister.title} />
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>

            <MainContent>
                <RiskRegisterTabs />
            </MainContent>
            <MainCardRoutingModal queryKeys={[]} />
        </PageContainer>
    );
};
